export default __webpack_public_path__ + "static/media/Background_00090.f3e95c88.png";